export default __webpack_public_path__ + "e38c4e939d9e9a4d64d00549b31b178c.svg";